import {cn} from '../../lib/utils';
import {DecorativeGrid} from '../EmptyState/DecorativeGrid';
import {Typography} from '../Typography';

import type {ReactNode} from 'react';

export interface ErrorStateProps {
  illustration?: ReactNode;
  title: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
}

export function ErrorState({illustration, title, subtitle, action, className}: ErrorStateProps) {
  return (
    <div
      data-slot="error-state"
      className={cn('relative flex flex-col items-center overflow-hidden py-16', className)}
    >
      <DecorativeGrid />

      <div className="relative z-10 flex flex-col items-center gap-8">
        <div className="flex flex-col items-center gap-5">
          {illustration && <div data-slot="error-state-illustration">{illustration}</div>}

          <div className="flex flex-col items-center gap-2 max-w-88 text-center">
            <Typography as="h3" size="lg" weight="semibold" className="whitespace-normal">
              {title}
            </Typography>
            {subtitle && (
              <Typography size="sm" color="tertiary" className="whitespace-normal">
                {subtitle}
              </Typography>
            )}
          </div>
        </div>

        {action && <div data-slot="error-state-action">{action}</div>}
      </div>
    </div>
  );
}
